import React from "react";

const SetDataTable = ({ setsData, blockIndex, levelIndex, onUpdateSetData }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm">
      <thead>
        <tr className="text-gray-500 border-b border-[#1E293B]">
          <th className="text-left py-2 px-2 w-16">Set #</th>
          <th className="text-left py-2 px-2">% of Max</th>
          <th className="text-left py-2 px-2">Reps</th>
          <th className="text-left py-2 px-2">Rest (mins)</th>
        </tr>
      </thead>
      <tbody>
        {setsData.map((sd, si) => (
          <tr key={si} className="border-b border-[#1E293B]/50">
            <td className="py-2 px-2">
              <span className="text-gray-400">{sd.set_num || si + 1}</span>
            </td>
            <td className="py-2 px-2">
              <input
                type="text"
                value={sd.percent_max}
                onChange={(e) => onUpdateSetData(blockIndex, levelIndex, si, "percent_max", e.target.value)}
                placeholder="e.g., 75"
                className="w-full bg-[#0B0F1A] border border-[#1E293B] rounded px-2 py-1 text-white focus:border-primary outline-none"
                data-testid={`percent-${blockIndex}-${levelIndex}-${si}`}
              />
            </td>
            <td className="py-2 px-2">
              <input
                type="text"
                value={sd.reps}
                onChange={(e) => onUpdateSetData(blockIndex, levelIndex, si, "reps", e.target.value)}
                placeholder="e.g., 5"
                className="w-full bg-[#0B0F1A] border border-[#1E293B] rounded px-2 py-1 text-white focus:border-primary outline-none"
                data-testid={`reps-${blockIndex}-${levelIndex}-${si}`}
              />
            </td>
            <td className="py-2 px-2">
              <input
                type="text"
                value={sd.rest_mins}
                onChange={(e) => onUpdateSetData(blockIndex, levelIndex, si, "rest_mins", e.target.value)}
                placeholder="e.g., 3"
                className="w-24 bg-[#0B0F1A] border border-[#1E293B] rounded px-2 py-1 text-white focus:border-primary outline-none"
                data-testid={`rest-${blockIndex}-${levelIndex}-${si}`}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SetDataTable;
